export enum AATestForFeatureExperimentationVariants {
	Control = 'control',
	VariationOne = 'variation_1',
	VariationTwo = 'variation_2',
}
